import { useCallback, useState } from "react";
import type { LogOption } from "@/components/activity/logOptions";

/** The log form and the next-step form every record page opens from its action bar (and the L key). */
export function useRecordCompose() {
  const [compose, setCompose] = useState<string | null>(null);
  const [nextStepOpen, setNextStepOpen] = useState(false);
  const openLog = useCallback((type: LogOption) => {
    setCompose(type);
    requestAnimationFrame(() => document.getElementById("record-activity")?.scrollIntoView({ behavior: "smooth", block: "start" }));
  }, []);
  return { compose, setCompose, openLog, nextStepOpen, setNextStepOpen };
}
